// mystery-gift.js — Mystery Dress promo reconciler
// Only loaded by theme.liquid while shop.metafields.custom.mystery_promo_on is true.
//
// Design contract (anti-rate-limit, post-tote-incident discipline):
//   - ZERO /cart.js reads. State comes ONLY from data attributes that
//     snippets/cart-mystery-gift.liquid computed server-side on the freshly
//     re-rendered cart section (Liquid is the source of truth).
//   - At most ONE cart write per eligibility transition, through the theme's
//     existing CartAPI queue. Convergence: the write triggers the theme's normal
//     section refresh, the new render matches the desired state, next pass no-ops.
//   - Circuit breaker: max 3 writes per rolling 60s, then park silently.
(function () {
  'use strict';
  if (window.__mysteryManager) return;
  window.__mysteryManager = true;

  var DISMISS_KEY = 'mystery:dismissed';
  var CONFLICT_KEY = 'mystery:codeConflict';
  var LOCK_KEY = 'mystery:writeLock';
  var timer = null;
  var inFlight = false;
  var writeTimes = [];

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function lockedByOtherTab() {
    try {
      var t = parseInt(localStorage.getItem(LOCK_KEY) || '0', 10);
      return Date.now() - t < 5000 && localStorage.getItem(LOCK_KEY + ':tab') !== tabId;
    } catch (e) { return false; }
  }
  var tabId = String(Math.random()).slice(2);
  function takeLock() {
    try {
      localStorage.setItem(LOCK_KEY, String(Date.now()));
      localStorage.setItem(LOCK_KEY + ':tab', tabId);
    } catch (e) {}
  }

  function breakerTripped() {
    var now = Date.now();
    writeTimes = writeTimes.filter(function (t) { return now - t < 60000; });
    return writeTimes.length >= 3;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  function reconcile() {
    var cfg = document.querySelector('[data-mystery-config]');
    if (!cfg || !window.CartAPI) return;            // promo off / not rendered → inert

    // Show the "code conflict" note if a previous pass removed a paid gift
    if (ss(true, CONFLICT_KEY) === '1') {
      var note = document.querySelector('[data-mystery-conflict-note]');
      if (note) note.hidden = false;
    }

    if (inFlight || lockedByOtherTab() || breakerTripped()) return;

    var parts = (cfg.getAttribute('data-mystery-sig') || '0:0').split(':');
    var qual = parseInt(parts[0], 10) || 0;
    var gift = parseInt(parts[1], 10) || 0;
    var key = cfg.getAttribute('data-mystery-line-key');
    var variantId = parseInt(cfg.getAttribute('data-mystery-variant'), 10);
    var paid = cfg.getAttribute('data-mystery-paid') === 'true';

    // Re-qualification clears a manual dismissal only once eligibility was lost
    if (qual < 2) ss(false, DISMISS_KEY, null);

    var job = null;
    if (gift > 0 && paid) {
      // BXGY didn't apply (discount-code collision) — never leave a customer
      // silently paying for a "free" dress. Remove + dismiss (prevents re-add loop).
      ss(false, DISMISS_KEY, '1');
      ss(false, CONFLICT_KEY, '1');
      job = key ? window.CartAPI.change(key, 0) : null;
    } else if (gift > 1) {
      job = key ? window.CartAPI.change(key, 1) : null;      // clamp qty abuse
    } else if (gift >= 1 && qual < 2) {
      job = key ? window.CartAPI.change(key, 0) : null;      // auto-remove
    } else if (gift === 0 && qual >= 2 && ss(true, DISMISS_KEY) !== '1') {
      ss(false, CONFLICT_KEY, null);
      job = window.CartAPI.add(variantId, 1, { _mystery: 'true' }); // auto-add
    }
    if (!job) return;

    inFlight = true;
    takeLock();
    writeTimes.push(Date.now());
    job.catch(function () { /* park silently; next cart change re-evaluates */ })
      .then(function () { inFlight = false; });
  }

  // Customer manually removes the gift → respect it, don't re-add this session
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('[data-remove-link]');
    if (link && link.getAttribute('data-product-handle') === 'free-mystery-dress') {
      ss(false, DISMISS_KEY, '1');
    }
  }, true);

  // Fired by sections.cart.js AFTER the section re-render lands in the DOM —
  // the only moment the data attributes are guaranteed fresh.
  document.addEventListener('cart:section-refreshed', schedule);

  // Initial pass for the server-rendered /cart page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
